import CreateEvent from "../../components/cubes/create-event.component"
import CubeCalendar from "../../components/cubes/cube-calendar.component"
import CubeHome from "../../components/cubes/cube-details-home.component"
import CubeEvents from "../../components/cubes/cube-events.component"
import CubeSensors from "../../components/cubes/cube-sensors.component"
import UpdateCube from "../../components/cubes/cube-update.component"
import { ERoles } from "../../constants/enum"
import { ISubPageRoute } from "../../interfaces/pages"

const cubesRoutes: ISubPageRoute[] = [
    {
        path: "/admin/cubes/:id",
        name: "Details",
        component: CubeHome,
        permission: [ERoles.SUPERADMIN, ERoles.OPERATOR, ERoles.REGIONADMIN, ERoles.SUPPLIER, ERoles.ORGANIZER],
    },
    {
        path: "/admin/cubes/:id/update",
        name: "Edit",
        component: UpdateCube,
        permission: [ERoles.SUPERADMIN],
    },
    {
        path: "/admin/cubes/:id/events",
        name: "Events",
        component: CubeEvents,
        permission: [ERoles.SUPERADMIN, ERoles.OPERATOR, ERoles.REGIONADMIN, ERoles.ORGANIZER],
    },
    {
        path: "/admin/cubes/:id/createres",
        name: "Add event",
        component: CreateEvent,
        permission: [],
    },
    {
        path: "/admin/cubes/:id/calendar",
        name: "Calendar",
        component: CubeCalendar,
        permission: [ERoles.SUPERADMIN, ERoles.OPERATOR, ERoles.REGIONADMIN],
    },

    {
        path: "/admin/cubes/:id/sensors",
        name: "Sensors",
        component: CubeSensors,
        permission: [ERoles.SUPERADMIN, ERoles.OPERATOR, ERoles.REGIONADMIN],
    }
]

export default cubesRoutes
